module.exports = __webpack_public_path__ + "static/insetviz-be77ee8c0ab29ccda899743cd9a9b339.png";